import React from 'react'
import { DragHandleDotsIcon } from '@/assets/icons/DragHandleDotsIcon'
import {
  SortableCard,
  useDragHandle,
} from '@/designs/new/components/atom/sortableSection/SortableCard'

type SortableTabCardProps = {
  id: string
  children: React.ReactNode
  className?: string
}

const SortableTabCardContent = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { listeners, attributes } = useDragHandle()

  return (
    <div className='group relative h-full'>
      <div
        {...listeners}
        {...attributes}
        className='absolute p-2 top-0.5 left-1/2 z-20 -translate-x-1/2 cursor-grab touch-none opacity-0 transition-opacity group-hover:opacity-100 active:cursor-grabbing'
      >
        <DragHandleDotsIcon />
      </div>
      {children}
    </div>
  )
}

const SortableTabCard = ({
  id,
  children,
  className = '',
}: SortableTabCardProps) => {
  return (
    <SortableCard id={id} className={className}>
      <SortableTabCardContent>{children}</SortableTabCardContent>
    </SortableCard>
  )
}

export default SortableTabCard
